/* Box Set theme scripts. No dependencies. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* ---------------------------------------------------------------------
     Money
     ------------------------------------------------------------------ */
  function formatMoney(cents, format) {
    format = format || theme.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    var pattern = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(pattern);
    if (!match) return format;

    function fmt(amount, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var parts = (amount / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(pattern, value);
  }

  // The store's money format may contain HTML (for example a small currency tag).
  function setMoney(el, cents) {
    if (el) el.innerHTML = formatMoney(cents);
  }

  /* ---------------------------------------------------------------------
     Dialogs (drawers, search, quick look, zoom)
     ------------------------------------------------------------------ */
  var CLOSE_MS = 300;

  function openDialog(dialog, opener) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (!dialog.open) {
      dialog._opener = opener || document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('no-scroll');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { dialog.classList.add('is-open'); });
      });
      dialog.dispatchEvent(new CustomEvent('dialog:open'));
    }
    return true;
  }

  function closeDialog(dialog, immediate) {
    if (!dialog || !dialog.open) return;
    dialog.classList.remove('is-open');
    var done = function () {
      if (dialog.open) dialog.close();
    };
    if (immediate || reduceMotion.matches) done();
    else setTimeout(done, CLOSE_MS);
  }

  var dialogsBooted = false;

  function initDialogs() {
    $$('dialog').forEach(function (dialog) {
      if (dialog.hasAttribute('data-dialog-bound')) return;
      dialog.setAttribute('data-dialog-bound', '');
      if (dialog.id === 'ZoomDialog') {
        dialog.addEventListener('click', function () { closeDialog(dialog); });
      }
      dialog.addEventListener('cancel', function (e) {
        e.preventDefault();
        closeDialog(dialog);
      });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('[data-dialog-close]')) closeDialog(dialog);
      });
      dialog.addEventListener('close', function () {
        dialog.classList.remove('is-open');
        if (!$$('dialog[open]').length) document.documentElement.classList.remove('no-scroll');
        var opener = dialog._opener;
        if (opener && document.contains(opener) && typeof opener.focus === 'function') opener.focus();
      });
    });

    if (dialogsBooted) return;
    dialogsBooted = true;
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-dialog-open]');
      if (!trigger) return;
      var dialog = document.getElementById(trigger.getAttribute('data-dialog-open'));
      if (dialog && openDialog(dialog, trigger)) e.preventDefault();
    });
  }

  /* ---------------------------------------------------------------------
     Header: scrolled state, dropdowns, announcement rotation
     ------------------------------------------------------------------ */
  function initHeader() {
    var root = document.documentElement;
    var ticking = false;
    var scrolled = false;
    // Shrinking the sticky header moves the page by about its own height change, so the
    // switch points are kept far apart; otherwise the header flickers near the threshold.
    var anchorTimer = null;
    var SHRINK_AT = 160;
    var GROW_AT = 8;
    var update = function () {
      var y = window.scrollY;
      if (!scrolled && y > SHRINK_AT) {
        scrolled = true;
        root.classList.add('is-scrolled');
      } else if (scrolled && y < GROW_AT) {
        scrolled = false;
        // Near the top, let the header grow without the browser nudging the scroll position.
        root.style.overflowAnchor = 'none';
        root.classList.remove('is-scrolled');
        clearTimeout(anchorTimer);
        anchorTimer = setTimeout(function () { root.style.overflowAnchor = ''; }, 450);
      }
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    update();

    var dropdowns = $$('[data-nav-dropdown]');
    document.addEventListener('click', function (e) {
      dropdowns.forEach(function (d) {
        if (d.open && !d.contains(e.target)) d.open = false;
      });
    });
    dropdowns.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) dropdowns.forEach(function (o) { if (o !== d) o.open = false; });
      });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && d.open) {
          d.open = false;
          $('summary', d).focus();
        }
      });
      d.addEventListener('focusout', function (e) {
        if (d.open && e.relatedTarget && !d.contains(e.relatedTarget)) d.open = false;
      });
    });

    $$('[data-rotate]').forEach(function (wrap) {
      var items = $$('.announcement__message', wrap);
      if (items.length < 2 || reduceMotion.matches) return;
      var i = 0;
      var paused = false;
      wrap.addEventListener('mouseenter', function () { paused = true; });
      wrap.addEventListener('mouseleave', function () { paused = false; });
      wrap.addEventListener('focusin', function () { paused = true; });
      wrap.addEventListener('focusout', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 5000);
    });
  }

  /* ---------------------------------------------------------------------
     Cart (AJAX + drawer)
     ------------------------------------------------------------------ */
  var cartDrawer = null;

  function updateCountBubbles(count) {
    $$('[data-cart-count-bubble]').forEach(function (bubble) {
      bubble.textContent = count;
      bubble.hidden = Number(count) === 0;
      bubble.classList.remove('is-bumped');
      void bubble.offsetWidth;
      bubble.classList.add('is-bumped');
    });
  }

  function renderCartDrawer(html) {
    if (!cartDrawer || !html) return;
    var fresh = $('[data-cart-drawer-inner]', parseHTML(html));
    var current = $('[data-cart-drawer-inner]', cartDrawer);
    if (!fresh || !current) return;
    current.replaceWith(fresh);
    updateCountBubbles(fresh.getAttribute('data-cart-count'));
  }

  function cartFetch(url, body, isJson) {
    var headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    if (isJson) headers['Content-Type'] = 'application/json';
    return fetch(url, {
      method: 'POST',
      headers: headers,
      body: isJson ? JSON.stringify(body) : body
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var message = data.description || data.message || theme.strings.cartError;
          if (typeof message !== 'string') message = theme.strings.cartError;
          throw new Error(message);
        }
        return data;
      });
    });
  }

  function addToCart(form, submitter) {
    var button = submitter || $('[type="submit"]', form);
    var errorEl = $('[data-form-error]', form);
    var wasDisabled = button ? button.disabled : false;
    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);

    if (errorEl) errorEl.hidden = true;
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    }

    cartFetch(theme.routes.cartAdd + '.js', body, false)
      .then(function (data) {
        if (!cartDrawer) {
          window.location.href = theme.routes.cart;
          return;
        }
        renderCartDrawer(data.sections && data.sections['cart-drawer']);
        var quickView = $('#QuickView');
        var inQuickView = quickView && button && quickView.contains(button);
        var opener = button && !inQuickView ? button : null;
        if (quickView && quickView.open) closeDialog(quickView, true);
        openDialog(cartDrawer, opener);
      })
      .catch(function (err) {
        if (errorEl) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        } else {
          window.alert(err.message);
        }
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-busy');
          button.disabled = wasDisabled;
        }
      });
  }

  function changeLine(line, quantity) {
    if (!cartDrawer) return;
    var focusedLine = document.activeElement && document.activeElement.closest('[data-line]');
    var focusKey = focusedLine ? focusedLine.getAttribute('data-line') : null;
    cartDrawer.classList.add('is-busy');
    cartFetch(theme.routes.cartChange + '.js', {
      line: Number(line),
      quantity: Math.max(0, Number(quantity) || 0),
      sections: ['cart-drawer'],
      sections_url: window.location.pathname
    }, true)
      .then(function (data) {
        renderCartDrawer(data.sections && data.sections['cart-drawer']);
        var target = focusKey && $('[data-line="' + focusKey + '"] [data-drawer-qty-input]', cartDrawer);
        (target || $('[data-dialog-close]', cartDrawer) || cartDrawer).focus();
      })
      .catch(function (err) {
        var errorEl = $('[data-cart-error]', cartDrawer);
        if (errorEl) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        }
      })
      .finally(function () {
        cartDrawer.classList.remove('is-busy');
      });
  }

  function initCart() {
    cartDrawer = theme.cartType === 'drawer' ? $('#CartDrawer') : null;

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('[data-ajax-cart]') || !cartDrawer) return;
      e.preventDefault();
      addToCart(form, e.submitter);
    });

    if (!cartDrawer) return;

    cartDrawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-drawer-qty]');
      if (!btn) return;
      changeLine(btn.getAttribute('data-line'), btn.getAttribute('data-drawer-qty'));
    });

    cartDrawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-drawer-qty-input]');
      if (!input) return;
      changeLine(input.getAttribute('data-line'), input.value);
    });

    // Keep the drawer fresh when the page is restored from bfcache.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      fetch(theme.routes.root + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) { renderCartDrawer(data['cart-drawer']); })
        .catch(function () {});
    });
  }

  function initCartPage() {
    var form = $('[data-cart-form]');
    if (!form) return;
    var submit = debounce(function () {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'update';
      hidden.value = '1';
      form.appendChild(hidden);
      form.submit();
    }, 700);
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-cart-qty]')) submit();
    });
  }

  /* ---------------------------------------------------------------------
     Quantity steppers (product page, quick look, cart page)
     ------------------------------------------------------------------ */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      var input = $('input[type="number"]', btn.parentElement);
      if (!input) return;
      var min = input.min !== '' ? Number(input.min) : 0;
      var next = Math.max(min, (Number(input.value) || 0) + Number(btn.getAttribute('data-qty-step')));
      if (next !== Number(input.value)) {
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  /* ---------------------------------------------------------------------
     Product forms: variant selection, price, gallery, sticky bar
     ------------------------------------------------------------------ */
  function initProduct(root) {
    if (!root || root.hasAttribute('data-bound')) return;
    root.setAttribute('data-bound', '');

    var jsonEl = $('[data-variants-json]', root);
    var variants = [];
    try { variants = jsonEl ? JSON.parse(jsonEl.textContent) : []; } catch (err) { variants = []; }

    var picker = $('[data-variant-picker]', root);
    var idInput = $('[data-variant-id]', root);
    var buttons = $$('[data-add-button]', root);
    var gallery = $('[data-gallery]', root);

    if (gallery) initGallery(gallery);
    if (!picker || !variants.length) return;

    function selectedOptions() {
      return $$('[data-option-index]', picker).map(function (group) {
        var select = $('select', group);
        if (select) return select.value;
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function markAvailability(selected) {
      $$('[data-option-index]', picker).forEach(function (group, index) {
        $$('input[type="radio"]', group).forEach(function (input) {
          var candidate = selected.slice();
          candidate[index] = input.value;
          var ok = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === candidate[i]; });
          });
          input.classList.toggle('is-unavailable', !ok);
        });
        var label = $('[data-option-selected]', group);
        if (label) label.textContent = selected[index] || '';
      });
    }

    function update() {
      var selected = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      markAvailability(selected);

      buttons.forEach(function (btn) {
        if (!variant) {
          btn.disabled = true;
          btn.textContent = theme.strings.unavailable;
        } else {
          btn.disabled = !variant.available;
          btn.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
        }
      });
      if (!variant) return;

      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      $$('[data-price]', root).forEach(function (price) {
        price.classList.toggle('price--sale', !!onSale);
        var current = $('[data-price-current]', price);
        setMoney(current, variant.price);
        var compareWrap = $('[data-price-compare-wrap]', price);
        var compare = $('[data-price-compare]', price);
        if (compareWrap) compareWrap.hidden = !onSale;
        if (onSale) setMoney(compare, variant.compare_at_price);
        var badge = $('[data-price-badge]', price);
        if (badge) badge.hidden = !onSale;
        var label = $('[data-price-label]', price);
        if (label) label.hidden = true;
      });

      $$('[data-sticker-price]', root).forEach(function (el) { setMoney(el, variant.price); });
      setMoney($('[data-sticky-price]', root), variant.price);

      var sku = $('[data-sku]', root);
      if (sku) {
        sku.hidden = !variant.sku;
        var skuValue = $('[data-sku-value]', sku);
        if (skuValue) skuValue.textContent = variant.sku || '';
      }

      if (variant.featured_media && gallery) {
        var thumb = $('[data-thumb][data-media-id="' + variant.featured_media.id + '"]', gallery);
        if (thumb) thumb.click();
      }

      if (root.matches('.product')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('change', update);
    markAvailability(selectedOptions());
  }

  function initGallery(gallery) {
    var stage = $('[data-stage]', gallery);
    var frontImg = $('.gallery__face--front .gallery__img', gallery);
    var frontZoom = $('.gallery__face--front [data-zoom-open]', gallery);
    var backZoom = $('.gallery__face--back [data-zoom-open]', gallery);
    var backFace = $('.gallery__face--back', gallery);
    var flipBtn = $('[data-flip]', gallery);
    var flipLabel = $('[data-flip-label]', gallery);
    var thumbs = $$('[data-thumb]', gallery);

    function setFlipped(on) {
      if (!stage) return;
      stage.classList.toggle('is-flipped', on);
      if (flipBtn) flipBtn.setAttribute('aria-pressed', String(on));
      if (flipLabel) flipLabel.textContent = on ? theme.strings.showFront : theme.strings.showBack;
      if (backFace) backFace.setAttribute('aria-hidden', String(!on));
      if (backZoom) backZoom.tabIndex = on ? 0 : -1;
      if (frontZoom) frontZoom.tabIndex = on ? -1 : 0;
    }

    function setCurrent(thumb) {
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
    }

    if (flipBtn) {
      flipBtn.addEventListener('click', function () {
        var next = !stage.classList.contains('is-flipped');
        setFlipped(next);
        var target = thumbs.filter(function (t) {
          return next ? t.getAttribute('data-face') === 'back' : t.getAttribute('data-face') !== 'back';
        })[0];
        if (target && next) setCurrent(target);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setCurrent(thumb);
        if (thumb.getAttribute('data-face') === 'back') {
          setFlipped(true);
          return;
        }
        if (frontImg) {
          frontImg.removeAttribute('srcset');
          var srcset = thumb.getAttribute('data-srcset');
          if (srcset) frontImg.setAttribute('srcset', srcset);
          frontImg.src = thumb.getAttribute('data-src');
          frontImg.alt = thumb.getAttribute('data-alt') || '';
        }
        if (frontZoom) frontZoom.setAttribute('data-zoom-src', thumb.getAttribute('data-zoom-src'));
        setFlipped(false);
      });
    });

    if (stage) setFlipped(false);
  }

  function initZoom() {
    var zoom = $('#ZoomDialog');
    if (!zoom) return;
    var img = $('[data-zoom-img]', zoom);
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-zoom-open]');
      if (!trigger) return;
      var inner = trigger.querySelector('img');
      img.src = trigger.getAttribute('data-zoom-src');
      img.alt = inner ? inner.alt : '';
      openDialog(zoom, trigger);
    });
  }

  function initStickyBar() {
    var bar = $('[data-sticky-atc]');
    var main = $('[data-main-add]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var barBtn = $('[data-add-button]', bar);
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      if (barBtn) barBtn.tabIndex = show ? 0 : -1;
    }).observe(main);
  }

  /* ---------------------------------------------------------------------
     Quick look
     ------------------------------------------------------------------ */
  function initQuickView() {
    var dialog = $('#QuickView');
    if (!dialog) return;
    var body = $('[data-quick-view-body]', dialog);
    var request = 0;

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-view]');
      if (!trigger) return;
      e.preventDefault();
      var url = trigger.getAttribute('data-quick-view');
      var token = ++request;
      body.innerHTML = '';
      var loading = document.createElement('p');
      loading.className = 'modal__loading';
      loading.setAttribute('role', 'status');
      loading.textContent = theme.strings.loading + '…';
      body.appendChild(loading);
      openDialog(dialog, trigger);

      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view')
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        })
        .then(function (html) {
          if (token !== request) return;
          var content = $('[data-quick-view-content]', parseHTML(html));
          if (!content) throw new Error('missing');
          body.replaceChildren(content);
          initProduct(content);
          var title = $('.qv__title', content);
          if (title) {
            title.id = 'QuickViewTitle';
            dialog.setAttribute('aria-labelledby', 'QuickViewTitle');
          }
        })
        .catch(function () {
          if (token === request) window.location.href = url;
        });
    });
  }

  /* ---------------------------------------------------------------------
     Predictive search
     ------------------------------------------------------------------ */
  function initSearch() {
    var dialog = $('#SearchOverlay');
    if (!dialog) return;
    var input = $('[data-predictive-input]', dialog);
    var results = $('[data-predictive-results]', dialog);
    var status = $('[data-predictive-status]', dialog);
    var controller = null;

    dialog.addEventListener('dialog:open', function () {
      setTimeout(function () { input.focus(); input.select(); }, 50);
    });

    var run = debounce(function () {
      var q = input.value.trim();
      if (controller) controller.abort();
      if (q.length < 2) {
        results.innerHTML = '';
        status.textContent = '';
        return;
      }
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = theme.routes.predictiveSearch +
        '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,page,query' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        })
        .then(function (html) {
          var content = $('[data-predictive-content]', parseHTML(html));
          results.replaceChildren();
          if (content) {
            results.appendChild(content);
            status.textContent = theme.strings.searchUpdated;
          }
        })
        .catch(function () {});
    }, 220);

    input.addEventListener('input', run);
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown') return;
      var first = $('a', results);
      if (first) {
        e.preventDefault();
        first.focus();
      }
    });
    results.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = $$('a', results);
      var index = links.indexOf(document.activeElement);
      if (index === -1) return;
      e.preventDefault();
      if (e.key === 'ArrowDown') (links[index + 1] || links[0]).focus();
      else if (index === 0) input.focus();
      else links[index - 1].focus();
    });
  }

  /* ---------------------------------------------------------------------
     Hero slideshow
     ------------------------------------------------------------------ */
  function initHero(hero) {
    var slides = $$('[data-slide]', hero);
    if (slides.length < 2) return;
    var dots = $$('[data-hero-dot]', hero);
    var toggle = $('[data-hero-toggle]', hero);
    var index = 0;
    var timer = null;
    var userPaused = false;
    var speed = (Number(hero.getAttribute('data-speed')) || 7) * 1000;
    var autoplay = hero.getAttribute('data-autoplay') === 'true';

    function go(next) {
      var prev = slides[index];
      index = (next + slides.length) % slides.length;
      var cur = slides[index];
      if (prev === cur) return;
      prev.classList.remove('is-active');
      prev.setAttribute('aria-hidden', 'true');
      prev.inert = true;
      cur.classList.add('is-active');
      cur.removeAttribute('aria-hidden');
      cur.inert = false;
      dots.forEach(function (d, i) { d.setAttribute('aria-current', String(i === index)); });
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    function play() {
      stop();
      if (!autoplay || userPaused || reduceMotion.matches) return;
      timer = setInterval(function () {
        if (!document.hidden) go(index + 1);
      }, speed);
    }

    function setPaused(paused) {
      userPaused = paused;
      if (toggle) {
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? theme.strings.play : theme.strings.pause);
        $('[data-icon-pause]', toggle).hidden = paused;
        $('[data-icon-play]', toggle).hidden = !paused;
      }
      if (paused) stop();
      else play();
    }

    var prevBtn = $('[data-hero-prev]', hero);
    var nextBtn = $('[data-hero-next]', hero);
    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); play(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); play(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); play(); });
    });
    if (toggle) toggle.addEventListener('click', function () { setPaused(!userPaused); });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', function (e) {
      if (!hero.contains(e.relatedTarget)) play();
    });

    var startX = null;
    hero.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) {
        go(dx < 0 ? index + 1 : index - 1);
        play();
      }
      startX = null;
    });

    if (reduceMotion.matches && toggle) setPaused(true);
    play();

    document.addEventListener('shopify:block:select', function (e) {
      var i = slides.indexOf(e.target);
      if (i > -1) {
        go(i);
        stop();
      }
    });
  }

  /* ---------------------------------------------------------------------
     Spine shelf
     ------------------------------------------------------------------ */
  function sampleColor(src) {
    return new Promise(function (resolve) {
      if (!src) return resolve(null);
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () {
        try {
          var size = 28;
          var canvas = document.createElement('canvas');
          canvas.width = size;
          canvas.height = size;
          var ctx = canvas.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0, size, size);
          var data = ctx.getImageData(0, 0, size, size).data;
          var buckets = {};
          var best = null;
          for (var p = 0; p < data.length; p += 4) {
            if (data[p + 3] < 200) continue;
            var r = data[p], g = data[p + 1], b = data[p + 2];
            var max = Math.max(r, g, b);
            var min = Math.min(r, g, b);
            var sat = max === 0 ? 0 : (max - min) / max;
            if (max > 235 && sat < 0.12) continue;
            if (max < 22) continue;
            var key = (r >> 4) + '-' + (g >> 4) + '-' + (b >> 4);
            var bucket = buckets[key] || (buckets[key] = { w: 0, n: 0, r: 0, g: 0, b: 0 });
            bucket.w += 1 + sat * 2.5;
            bucket.n += 1;
            bucket.r += r;
            bucket.g += g;
            bucket.b += b;
            if (!best || bucket.w > best.w) best = bucket;
          }
          if (!best) return resolve(null);
          resolve([Math.round(best.r / best.n), Math.round(best.g / best.n), Math.round(best.b / best.n)]);
        } catch (err) {
          resolve(null);
        }
      };
      img.onerror = function () { resolve(null); };
      img.src = src;
    });
  }

  function luminance(rgb) {
    var c = rgb.map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }

  /* ---------------------------------------------------------------------
     Real spines from 3D box art
     Finds the side face of a rendered box (transparent PNG), straightens it
     and returns it as an image. Returns null whenever it is not confident.
     ------------------------------------------------------------------ */
  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function fitLine(profile, from, to) {
    var n = 0, sx = 0, sy = 0, sxx = 0, sxy = 0, x, y;
    for (x = from; x < to; x++) {
      y = profile[x];
      if (y < 0) continue;
      n++; sx += x; sy += y; sxx += x * x; sxy += x * y;
    }
    if (n < 3) return null;
    var d = n * sxx - sx * sx;
    if (!d) return null;
    var m = (n * sxy - sx * sy) / d;
    var b = (sy - m * sx) / n;
    var sse = 0;
    for (x = from; x < to; x++) {
      y = profile[x];
      if (y < 0) continue;
      var e = y - (m * x + b);
      sse += e * e;
    }
    return { m: m, b: b, sse: sse, rms: Math.sqrt(sse / n), n: n };
  }

  function findSpineFace(top, bottom, x0, x1) {
    var bw = x1 - x0 + 1;
    var minW = Math.max(4, Math.round(bw * 0.03));
    var maxW = Math.round(bw * 0.4);
    var best = null;
    ['left', 'right'].forEach(function (side) {
      for (var w = minW; w <= maxW; w++) {
        var k = side === 'left' ? x0 + w : x1 - w;
        var inner = side === 'left' ? [x0 + 1, k] : [k + 1, x1];
        var outer = side === 'left' ? [k + 1, x1] : [x0 + 1, k];
        var sT = fitLine(top, inner[0], inner[1]);
        var fT = fitLine(top, outer[0], outer[1]);
        if (!sT || !fT) continue;
        var score = sT.sse + fT.sse;
        if (!best || score < best.score) best = { side: side, k: k, inner: inner, outer: outer, score: score, sT: sT, fT: fT };
      }
    });
    if (!best) return null;
    var sB = fitLine(bottom, best.inner[0], best.inner[1]);
    var fB = fitLine(bottom, best.outer[0], best.outer[1]);
    if (!sB || !fB) return null;
    // A real side face is seen in perspective: its top and bottom edges slope
    // in opposite directions, converging towards the far edge.
    // Parallel-projection renders are also fine: then both pairs of edges are parallel.
    var towardsFar = best.side === 'left' ? best.sT.m < 0 : best.sT.m > 0;
    var converging = towardsFar && best.sT.m * sB.m < 0 && Math.abs(best.sT.m) > 0.08 && Math.abs(sB.m) > 0.08;
    var parallel =
      Math.abs(best.sT.m) > 0.08 &&
      Math.abs(best.sT.m - sB.m) < Math.max(0.05, Math.abs(best.sT.m) * 0.2) &&
      Math.abs(best.fT.m - fB.m) < 0.05;
    best.projection = converging ? 'perspective' : 'parallel';
    var ok =
      (converging || parallel) &&
      Math.abs(best.sT.m) < 3 &&
      Math.abs(best.sT.m - best.fT.m) > 0.12 &&
      Math.abs(sB.m - fB.m) > 0.06 &&
      best.sT.rms < 1.3 && best.fT.rms < 1.8 && sB.rms < 1.8;
    if (!ok) return null;
    best.sB = sB;
    best.fB = fB;
    return best;
  }

  function extractSpine(src) {
    return loadImage(src).then(function (img) {
      var MW = 320;
      var MH = Math.round(img.naturalHeight * MW / img.naturalWidth);
      var mask = document.createElement('canvas');
      mask.width = MW;
      mask.height = MH;
      var mctx = mask.getContext('2d', { willReadFrequently: true });
      mctx.drawImage(img, 0, 0, MW, MH);
      var md = mctx.getImageData(0, 0, MW, MH).data;
      var alphaAt = function (x, y) { return md[(y * MW + x) * 4 + 3]; };

      var top = new Float32Array(MW).fill(-1);
      var bottom = new Float32Array(MW).fill(-1);
      var clear = 0;
      var x, y;
      for (x = 0; x < MW; x++) {
        for (y = 0; y < MH; y++) {
          var al = alphaAt(x, y);
          if (al < 16) clear++;
          if (al >= 240) {
            if (top[x] < 0) top[x] = y;
            bottom[x] = y;
          }
        }
      }
      // Only cut-out renders (transparent background) have a readable side face.
      if (clear / (MW * MH) < 0.04) return null;
      var x0 = -1, x1 = -1;
      for (x = 0; x < MW; x++) {
        if (top[x] >= 0) {
          if (x0 < 0) x0 = x;
          x1 = x;
        }
      }
      if (x0 < 0 || x1 - x0 < MW * 0.3) return null;

      var g = findSpineFace(top, bottom, x0, x1);
      if (!g) return null;

      var xa = g.inner[0] + 1;
      var xb = g.inner[1] - 1;
      if (xb - xa < 3) return null;
      var yT = function (xx) { return g.sT.m * xx + g.sT.b; };
      var yB = function (xx) { return g.sB.m * xx + g.sB.b; };
      var hA = yB(xa) - yT(xa);
      var hB = yB(xb) - yT(xb);
      if (hA < MH * 0.3 || hB < MH * 0.3) return null;
      // In perspective the far edge of the face is the shorter one; in parallel projection they match.
      var farH = g.side === 'left' ? hA : hB;
      var nearH = g.side === 'left' ? hB : hA;
      if (g.projection === 'perspective' && farH >= nearH * 0.995) return null;
      if (g.projection === 'parallel' && Math.abs(farH - nearH) > nearH * 0.03) return null;

      // The face must be solid, and look different from the front (it is shaded).
      var solid = 0, total = 0, sum = [0, 0, 0], fsum = [0, 0, 0], fcount = 0;
      for (x = xa; x <= xb; x++) {
        for (y = Math.ceil(yT(x)) + 1; y < Math.floor(yB(x)) - 1; y++) {
          total++;
          var p = (y * MW + x) * 4;
          if (md[p + 3] >= 240) {
            solid++;
            sum[0] += md[p]; sum[1] += md[p + 1]; sum[2] += md[p + 2];
          }
        }
      }
      if (!total || solid / total < 0.97) return null;
      var fx0 = g.side === 'left' ? g.k + 2 : g.k - 12;
      for (x = fx0; x < fx0 + 10; x++) {
        var ft = top[x], fb = bottom[x];
        if (ft < 0) continue;
        for (y = Math.round(ft + (fb - ft) * 0.2); y < ft + (fb - ft) * 0.8; y++) {
          var q = (y * MW + x) * 4;
          fsum[0] += md[q]; fsum[1] += md[q + 1]; fsum[2] += md[q + 2];
          fcount++;
        }
      }
      var lum = function (c, n) { return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / Math.max(1, n); };
      var spineLum = lum(sum, solid);
      var frontLum = lum(fsum, fcount);

      // Estimate the true thickness: the front of a DVD case is about 0.71 as wide as it is tall.
      var scale = img.naturalWidth / MW;
      var frontW = (g.side === 'left' ? x1 - g.k : g.k - x0) * scale;
      var sharedH = (g.side === 'left' ? hB : hA) * scale;
      var cosT = Math.min(0.98, (frontW / sharedH) / 0.71);
      var sinT = Math.max(0.2, Math.sqrt(1 - cosT * cosT));
      var faceH = Math.max(hA, hB) * scale;
      var apparentW = (g.side === 'left' ? g.k - x0 : x1 - g.k) * scale;
      var ratio = Math.min(0.32, Math.max(0.05, (apparentW / sinT) / faceH));

      // Sample the face at full resolution.
      var sx = Math.floor(xa * scale);
      var sy = Math.floor(Math.min(yT(xa), yT(xb)) * scale);
      var sw = Math.ceil((xb - xa + 1) * scale);
      var sh = Math.ceil((Math.max(yB(xa), yB(xb)) - Math.min(yT(xa), yT(xb))) * scale);
      var src2 = document.createElement('canvas');
      src2.width = sw;
      src2.height = sh;
      var sctx = src2.getContext('2d', { willReadFrequently: true });
      sctx.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);
      var sd = sctx.getImageData(0, 0, sw, sh).data;

      var outH = Math.min(760, Math.round(faceH));
      var outW = Math.max(8, Math.round(outH * ratio));
      var out = document.createElement('canvas');
      out.width = outW;
      out.height = outH;
      var octx = out.getContext('2d');
      var od = octx.createImageData(outW, outH);
      var gain = spineLum > 0 ? Math.min(1.45, Math.max(1, (frontLum / spineLum) * 0.92)) : 1;
      var inset = 0.012;
      for (var j = 0; j < outH; j++) {
        var v = inset + (1 - 2 * inset) * (j + 0.5) / outH;
        for (var i = 0; i < outW; i++) {
          var u = 0.04 + 0.92 * (i + 0.5) / outW;
          var xm = xa + u * (xb - xa);
          var t = yT(xm), b = yB(xm);
          var ym = t + v * (b - t);
          var fxp = Math.min(sw - 1.001, Math.max(0, xm * scale - sx));
          var fyp = Math.min(sh - 1.001, Math.max(0, ym * scale - sy));
          var ix = Math.floor(fxp), iy = Math.floor(fyp);
          var ax = fxp - ix, ay = fyp - iy;
          var p00 = (iy * sw + ix) * 4, p10 = p00 + 4, p01 = p00 + sw * 4, p11 = p01 + 4;
          var oi = (j * outW + i) * 4;
          for (var ch = 0; ch < 3; ch++) {
            var val =
              (sd[p00 + ch] * (1 - ax) + sd[p10 + ch] * ax) * (1 - ay) +
              (sd[p01 + ch] * (1 - ax) + sd[p11 + ch] * ax) * ay;
            od.data[oi + ch] = Math.min(255, val * gain);
          }
          od.data[oi + 3] = 255;
        }
      }
      octx.putImageData(od, 0, 0);
      return new Promise(function (resolve) {
        out.toBlob(function (blob) {
          resolve(blob ? { url: URL.createObjectURL(blob), ratio: ratio } : null);
        }, 'image/png');
      });
    }).catch(function () {
      return null;
    });
  }

  function applySpinePhoto(spine, result) {
    var face = $('[data-spine-toggle]', spine);
    if (!face) return;
    var img = document.createElement('img');
    img.className = 'spine__photo';
    img.alt = '';
    img.decoding = 'async';
    img.src = result.url;
    face.insertBefore(img, face.firstChild);
    spine.style.setProperty('--spine-ratio', result.ratio.toFixed(4));
    spine.classList.add('spine--photo', 'spine--extracted');
  }

  function initShelf(shelf) {
    var rack = $('[data-shelf-rack]', shelf);
    var spines = $$('[data-spine]', shelf);
    if (!rack || !spines.length) return;
    var hoverTimer = null;

    function open(spine, options) {
      options = options || {};
      spines.forEach(function (s) {
        var on = s === spine;
        s.classList.toggle('is-open', on);
        var toggle = $('[data-spine-toggle]', s);
        if (toggle) toggle.setAttribute('aria-expanded', String(on));
        var cover = $('.spine__cover', s);
        if (cover) cover.inert = !on;
      });
      if (options.reveal) {
        setTimeout(function () {
          var rackBox = rack.getBoundingClientRect();
          var box = spine.getBoundingClientRect();
          var delta = 0;
          if (box.right > rackBox.right) delta = box.right - rackBox.right + 8;
          else if (box.left < rackBox.left) delta = box.left - rackBox.left - 8;
          if (delta) rack.scrollBy({ left: delta, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        }, reduceMotion.matches ? 0 : 520);
      }
    }

    spines.forEach(function (spine, i) {
      var toggle = $('[data-spine-toggle]', spine);
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        open(spine, { reveal: true });
      });

      toggle.addEventListener('mouseenter', function () {
        if (!finePointer.matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { open(spine); }, 130);
      });
      toggle.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); });

      toggle.addEventListener('keydown', function (e) {
        var target = null;
        if (e.key === 'ArrowRight') target = spines[i + 1];
        else if (e.key === 'ArrowLeft') target = spines[i - 1];
        else if (e.key === 'Home') target = spines[0];
        else if (e.key === 'End') target = spines[spines.length - 1];
        if (!target) return;
        e.preventDefault();
        var t = $('[data-spine-toggle]', target);
        t.focus();
        open(target, { reveal: true });
      });
    });

    function colourPrinted(spine) {
      if (shelf.getAttribute('data-sample') !== 'true') return;
      var toggle = $('[data-spine-toggle]', spine);
      var src = toggle && toggle.getAttribute('data-sample-src');
      if (!src) return;
      sampleColor(src).then(function (rgb) {
        if (!rgb) return;
        spine.style.setProperty('--spine-bg', 'rgb(' + rgb.join(',') + ')');
        spine.setAttribute('data-fg', luminance(rgb) > 0.42 ? 'dark' : 'light');
      });
    }

    function warmUp() {
      $$('.spine__img, .spine__photo', shelf).forEach(function (img) { img.loading = 'eager'; });
      var queue = Promise.resolve();
      spines.forEach(function (spine) {
        if (spine.classList.contains('spine--photo')) return;
        var toggle = $('[data-spine-toggle]', spine);
        var art = toggle && toggle.getAttribute('data-spine-art');
        if (!art) {
          colourPrinted(spine);
          return;
        }
        // One at a time keeps the main thread free.
        queue = queue.then(function () {
          return extractSpine(art).then(function (result) {
            if (result) applySpinePhoto(spine, result);
            else colourPrinted(spine);
          });
        });
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          io.disconnect();
          warmUp();
        }
      }, { rootMargin: '300px' });
      io.observe(shelf);
    } else {
      warmUp();
    }
  }

  /* ---------------------------------------------------------------------
     Tabs
     ------------------------------------------------------------------ */
  function initTabs(root) {
    var tabs = $$('[role="tab"]', root);
    if (!tabs.length) return;
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        e.preventDefault();
        next.focus();
        select(next);
      });
    });
    document.addEventListener('shopify:block:select', function (e) {
      if (tabs.indexOf(e.target) > -1) select(e.target);
    });
  }

  /* ---------------------------------------------------------------------
     Collection filters and sorting
     ------------------------------------------------------------------ */
  function initFacets() {
    var form = $('[data-facet-form]');
    var panel = $('[data-facets-panel]');
    var overlay = $('.facets__overlay');
    var openBtn = $('[data-facets-open]');
    var mobile = window.matchMedia('(max-width: 989px)');

    function go() {
      if (!form) return;
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
      var action = form.getAttribute('action');
      window.location.href = action + (params.toString() ? '?' + params.toString() : '');
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        go();
      });
      form.addEventListener('change', function () {
        if (!mobile.matches) go();
      });
    }

    var sort = $('[data-sort-select]');
    if (sort) sort.addEventListener('change', go);

    if (!panel) return;

    function setOpen(on) {
      panel.classList.toggle('is-open', on);
      if (overlay) overlay.hidden = !on;
      if (openBtn) openBtn.setAttribute('aria-expanded', String(on));
      document.documentElement.classList.toggle('no-scroll', on);
      if (on) {
        var close = $('[data-facets-close]', panel);
        if (close) close.focus();
      } else if (openBtn) {
        openBtn.focus();
      }
    }

    if (openBtn) openBtn.addEventListener('click', function () { setOpen(true); });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-facets-close]') && panel.classList.contains('is-open')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) setOpen(false);
    });
    mobile.addEventListener('change', function () {
      if (!mobile.matches && panel.classList.contains('is-open')) setOpen(false);
    });
  }

  /* ---------------------------------------------------------------------
     Product recommendations
     ------------------------------------------------------------------ */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (section) {
      var url = section.getAttribute('data-url');
      if (!url || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        fetch(url)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var fresh = $('[data-recommendations]', parseHTML(html));
            if (fresh && fresh.innerHTML.trim()) section.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      }, { rootMargin: '400px' });
      io.observe(section);
    });
  }

  /* ---------------------------------------------------------------------
     Customer accounts
     ------------------------------------------------------------------ */
  function initAccounts() {
    var loginSection = $('.account-form [data-recover-panel]');
    if (loginSection) {
      var wrap = loginSection.closest('.account-form');
      var show = function (on) { wrap.classList.toggle('is-recovering', on); };
      if (window.location.hash === '#recover' || $('.notice', loginSection)) show(true);
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-recover-toggle]');
        if (!t) return;
        e.preventDefault();
        show(!wrap.classList.contains('is-recovering'));
      });
    }

    $$('[data-country-select]').forEach(function (select) {
      var def = select.getAttribute('data-default');
      if (def) select.value = def;
      var provinceId = select.getAttribute('data-province-target');
      var province = document.getElementById(provinceId);
      var container = province ? province.closest('.field') : null;
      var fill = function () {
        if (!province) return;
        var option = select.options[select.selectedIndex];
        var list = [];
        try { list = option ? JSON.parse(option.getAttribute('data-provinces') || '[]') : []; } catch (err) { list = []; }
        province.innerHTML = '';
        list.forEach(function (p) {
          var o = document.createElement('option');
          o.value = p[0];
          o.textContent = p[1];
          province.appendChild(o);
        });
        var pdef = province.getAttribute('data-default');
        if (pdef) province.value = pdef;
        if (container) container.hidden = list.length === 0;
      };
      select.addEventListener('change', function () {
        province.setAttribute('data-default', '');
        fill();
      });
      fill();
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-address-delete]');
      if (!btn) return;
      if (!window.confirm(theme.strings.deleteAddress)) return;
      var form = document.createElement('form');
      form.method = 'post';
      form.action = btn.getAttribute('data-address-delete');
      var method = document.createElement('input');
      method.type = 'hidden';
      method.name = '_method';
      method.value = 'delete';
      form.appendChild(method);
      document.body.appendChild(form);
      form.submit();
    });
  }

  /* ---------------------------------------------------------------------
     Boot
     ------------------------------------------------------------------ */
  function initVideos(scope) {
    $$('[data-video-play]', scope).forEach(function (btn) {
      if (btn.hasAttribute('data-bound')) return;
      btn.setAttribute('data-bound', '');
      btn.addEventListener('click', function () {
        var frame = btn.closest('[data-video]');
        var tpl = frame && $('[data-video-template]', frame);
        if (!tpl) return;
        var iframe = tpl.content.firstElementChild.cloneNode(true);
        btn.replaceWith(iframe);
        iframe.focus();
      });
    });
  }

  /* ---------------------------------------------------------------------
     Order tracking: detect the carrier and open its tracking page
     ------------------------------------------------------------------ */
  var CARRIER_URLS = {
    usps: 'https://tools.usps.com/go/TrackConfirmAction?tLabels={number}',
    ups: 'https://www.ups.com/track?tracknum={number}',
    fedex: 'https://www.fedex.com/fedextrack/?trknbr={number}',
    dhl: 'https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id={number}',
    canadapost: 'https://www.canadapost-postescanada.ca/track-reperage/en#/search?searchFor={number}',
    purolator: 'https://www.purolator.com/en/shipping/tracker?pin={number}'
  };

  function detectCarrier(n) {
    if (/^1Z[0-9A-Z]{16}$/.test(n)) return 'ups';
    if (/^T\d{10}$/.test(n)) return 'ups';
    if (/^[A-Z]{2}\d{9}CA$/.test(n)) return 'canadapost';
    if (/^[A-Z]{2}\d{9}US$/.test(n)) return 'usps';
    if (/^(9[1-5]\d{18}|9[1-5]\d{20}|420\d{5}9[1-5]\d{20}|82\d{8})$/.test(n)) return 'usps';
    if (/^(JJD\d{9,}|JVGL\d{6,}|GM\d{16,}|\d{10})$/.test(n)) return 'dhl';
    if (/^[A-Z]{3}\d{9}$/.test(n)) return 'purolator';
    if (/^\d{16}$/.test(n)) return 'canadapost';
    if (/^(\d{12}|\d{15}|96\d{20}|\d{20})$/.test(n)) return 'fedex';
    return null;
  }

  function initTracking(scope) {
    $$('[data-tracking]', scope).forEach(function (root) {
      if (root.hasAttribute('data-bound')) return;
      root.setAttribute('data-bound', '');
      var form = $('[data-tracking-form]', root);
      var input = $('[data-tracking-input]', root);
      var select = $('[data-tracking-carrier]', root);
      var message = $('[data-tracking-message]', root);
      var strings = theme.strings;
      var names = strings.carriers || {};

      function show(text, link, isError) {
        message.textContent = '';
        message.classList.toggle('is-error', !!isError);
        if (text) message.appendChild(document.createTextNode(text + ' '));
        if (link) {
          var a = document.createElement('a');
          a.href = link.href;
          a.target = '_blank';
          a.rel = 'noopener';
          a.className = 'text-link';
          a.textContent = link.label;
          message.appendChild(a);
        }
      }

      input.addEventListener('input', function () {
        input.removeAttribute('aria-invalid');
        if (message.classList.contains('is-error')) show('');
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var number = input.value.toUpperCase().replace(/[\s\-.]/g, '');
        if (!number) {
          input.setAttribute('aria-invalid', 'true');
          show(strings.trackingEmpty, null, true);
          input.focus();
          return;
        }
        if (!/^[A-Z0-9]{8,34}$/.test(number)) {
          input.setAttribute('aria-invalid', 'true');
          show(strings.trackingInvalid, null, true);
          input.focus();
          return;
        }
        var carrier = select.value !== 'auto' ? select.value : detectCarrier(number);
        if (!carrier) {
          var fallback = root.getAttribute('data-default-carrier');
          carrier = fallback && fallback !== 'auto' ? fallback : null;
        }
        var template = carrier ? CARRIER_URLS[carrier] : root.getAttribute('data-fallback-url');
        if (!template || template.indexOf('{number}') === -1) {
          show(strings.trackingInvalid, null, true);
          return;
        }
        var url = template.replace('{number}', encodeURIComponent(number));
        var name = carrier ? (names[carrier] || carrier) : strings.trackingOther;
        var opened = window.open(url, '_blank');
        if (opened) opened.opener = null;
        show(
          opened ? strings.trackingOpening.replace('[carrier]', name) : '',
          { href: url, label: strings.trackingOpenLink.replace('[carrier]', name) },
          false
        );
      });
    });
  }

  function initSection(scope) {
    initTracking(scope);
    initVideos(scope);
    $$('[data-hero]', scope).forEach(initHero);
    $$('[data-shelf]', scope).forEach(initShelf);
    $$('[data-tabs]', scope).forEach(initTabs);
    $$('[data-product-root]', scope).forEach(initProduct);
  }

  function boot() {
    initDialogs();
    initHeader();
    initCart();
    initCartPage();
    initQuantity();
    initZoom();
    initQuickView();
    initSearch();
    initSection(document);
    initStickyBar();
    initFacets();
    initRecommendations();
    initAccounts();

    // Theme editor: open a collapsible row when its block is selected.
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target && e.target.tagName === 'DETAILS') e.target.open = true;
    });

    // Re-run section scripts inside the theme editor.
    document.addEventListener('shopify:section:load', function (e) {
      initSection(e.target);
      initDialogs();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.BoxSet = { formatMoney: formatMoney, openDialog: openDialog, closeDialog: closeDialog, extractSpine: extractSpine };
})();
